import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const fetchProducts = () => api.get("/products").then((r) => r.data);
export const fetchTour = () => api.get("/tour").then((r) => r.data);
export const subscribeNewsletter = (email) =>
  api.post("/newsletter", { email }).then((r) => r.data);
export const createCheckout = (payload) =>
  api.post("/checkout", payload).then((r) => r.data);

export const createStripeSession = (payload) =>
  api.post("/checkout/session", payload).then((r) => r.data);

export const getStripeStatus = (sessionId) =>
  api.get(`/checkout/status/${sessionId}`).then((r) => r.data);
